import { Controller } from '@hotwired/stimulus'
import {
  Chart,
  LineController,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
} from 'chart.js'
import { toStonesAndPounds } from '../utils/weight-utils'

const lifestyleRangePlugin = {
  id: 'lifestyleRange',
  beforeDatasetsDraw(chart, _args, options) {
    const { range } = options
    if (!range) return

    const { ctx, chartArea, scales } = chart
    const lowerY = scales.y.getPixelForValue(range.lower)
    const upperY = scales.y.getPixelForValue(range.upper)
    const y = Math.min(lowerY, upperY)
    const height = Math.abs(lowerY - upperY)

    ctx.save()
    ctx.fillStyle = 'rgba(34, 197, 94, 0.14)'
    ctx.fillRect(chartArea.left, y, chartArea.right - chartArea.left, height)
    ctx.restore()
  },
}

Chart.register(
  LineController,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  lifestyleRangePlugin
)

function getLabels(weekData) {
  return Object.keys(weekData).reverse()
}

export default class extends Controller {
  static targets = ['chart']
  static values = {
    data: Object,
    range: Object,
  }

  connect() {
    if (!this.hasChartTarget) return

    // const [theme] = useTheme()
    // const textColour = theme === 'dark' ? '#fff' : '#333'
    // const borderColour =
    //   theme === 'dark' ? tailwindColours.gray[900] : tailwindColours.gray[100]
    // "100": "#f5f5f5"
    const borderColour = '#171717'
    const textColour = '#333'
    const computedStyle = getComputedStyle(document.body)

    const data = this.dataValue
    const range = this.hasRangeValue ? this.rangeValue : null
    new Chart(this.chartTarget, {
      type: 'line',
      borderColor: borderColour,
      responsive: true,
      options: {
        datasets: {
          line: {
            spanGaps: true,
          },
        },
        plugins: {
          lifestyleRange: {
            range,
          },
          legend: {
            display: false,
            position: 'bottom',
            labels: {
              color: textColour,
            },
          },
          tooltip: {
            callbacks: {
              label: ({ raw }) => {
                return toStonesAndPounds(raw)
              },
            },
          },
        },
        scales: {
          y: {
            suggestedMin: range?.lower,
            suggestedMax: range?.upper,
            ticks: {
              // stepSize: 7,
              stepSize: 14,
              callback: value => {
                return toStonesAndPounds(value)
              },
            },
          },
        },
      },
      data: {
        labels: getLabels(data),
        datasets: [
          {
            // backgroundColor: GRAPH_COLOURS,
            label: 'Weight history',
            data: Object.values(data).reverse(),
            borderColor: computedStyle.getPropertyValue('--color-primary-400'),
            backgroundColor: computedStyle.getPropertyValue(
              '--color-primary-500'
            ),
          },
        ],
      },
    })
  }
}
